import { Box } from "@mui/material";
import Button from "../../../design/Button";
import dialerNoVirtualNumber from "../../../../assets/dialerNoVirtualNumber.svg";
import "../TopNav/topNavStyles.css";


const NoTrialVNScreen = (props) => {

const handleOpenChatWidget = () => {
    if (!props.isWidgetOpen) {
      props.handleToggleWidget();
    }
};
  
  return (
    <Box
      sx={{
        height: "fit-content",
        width: "373px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItem: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "64px 16px",
          height: "399px",
          width: "373px",
        }}
      >
            <img
              style={{
                marginBottom: "24px",
                width: "169px",
                height: "135px",
              }}
              src={dialerNoVirtualNumber}
            />
            <div
              className="t7 regular-font nc-gray-900"
              style={{
                textAlign: "center",
                lineHeight: "24px",
                width: "243px",
              }}
            >
              Get your trial number to start calling, our team will assign one right away.
            </div>
            <Button
              hierarchy="green"
              variant="contained"
              buttonText="Contact chat support"
              styleOverride={{padding: '8px 12px', marginTop: '20px'}}
              onClick={handleOpenChatWidget}
            />
      </Box>
    </Box>
  );
};

export default NoTrialVNScreen;
